import { render, staticRenderFns } from "./LicenceBody.vue?vue&type=template&id=30a9724c&scoped=true&"
import script from "./LicenceBody.vue?vue&type=script&lang=js&"
export * from "./LicenceBody.vue?vue&type=script&lang=js&"
import style0 from "./LicenceBody.vue?vue&type=style&index=0&id=30a9724c&scoped=true&lang=css&"
import style1 from "./LicenceBody.vue?vue&type=style&index=1&id=30a9724c&scoped=true&lang=css&"
import style2 from "./LicenceBody.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a9724c",
  null
  
)

export default component.exports